import ApiService from "../../services/ApiService"
import { isLoading, setError, setSuccessMessage } from "./uxAction"

export function fetchPolicies(callback) {
    return async (dispatch) => {
        dispatch(isLoading(true))

        const resp = await ApiService.invokeGet(process.env.REACT_APP_API_URL + `/api/content`)

        dispatch(isLoading(false))

        if (resp.status === 200) {
            const { data } = resp.data
            await dispatch({
                type: 'FETCH_POLICIES',
                payload: data
            })


        if (callback)
            callback({ 
                filteredData: data
            })
        }
    }
}

export function updatePolicy({ policyId, policyName, policyContent }, callback) {
    return async (dispatch) => {
        try {
            dispatch(isLoading(true))

            const resp = await ApiService.invokePost(process.env.REACT_APP_API_URL + `/admin/api/secured/content/${policyName}`, {
                policyContent
            })

            dispatch(isLoading(false))

            if (resp.status >= 400)
                dispatch(setError(resp.data.errors))

            if (resp.status == 200) {
                dispatch(setSuccessMessage({
                    title: "Success",
                    subTitle: "Item updated"
                }))
            }
            
            if (callback)
                callback()


        } catch (e) { }
    }
}